import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { BidPriceFloor, Order, State } from 'core/order/Order';
import { Currency } from 'core';

interface UseOrder {
  order: Order;
  setOrder: (type: Order) => void;
}
export const useOrderStore = create<UseOrder>()(
  devtools((set) => ({
    order: {
      id: 0,
      projectName: '',
      orderNumber: '',
      agencyId: 0,
      advertiserId: 0,
      orderType: 'TENMAX',
      budget: 0,
      originBudget: 0,
      changeBudget: 0,
      externalId: '',
      externalType: '',
      state: State.APPROVE,
      spent: 0,
      creator: '',
      creatorEmail: '',
      expectedSpent: 0,
      actualSpent: 0,
      comments: '',
      startDate: '',
      endDate: '',
      createDate: '',
      createDateTime: '',
      campaignBidPrice: [] as {
        type: string;
        autoBidCap: BidPriceFloor;
        bidFloor: BidPriceFloor;
      }[],
      campaignConstraint: {
        budgetMinimum: 10,
        campaignBudgetMinimum: 10,
      },
      budgetBalance: 0,
      currency: Currency.NTD,
      timezone: '+08:00',
      impres: 0,
      clicks: 0,
      ctr: 0,
      roas: 0,
      modifyReason: '',
      l1Objects: [],
    },
    setOrder: (type: Order) => set({ order: type }),
  })),
);
